export default {
	title: "Web3",
	rule: "Rule Description",
	safe: "Fund Security",
	balance: {
		total: "Total Amount",
		yesterday: "Yesterday's Earnings",
		cumulatively: "Cumulative Earnings",
		in: "Deposit Amount",
		out: "Withdrawal Amount",
		available: "Available Balance"
	},
	actions: {
		in: "In",
		out: "Out"
	},
	type: ["All", "In", "Out", "Earnings"],
	TransactionPassword: "Transaction Password",
	Amount: "Amount",
	date: "Date"
};
